import React from "react";
import Navbar from "../header";
import Footer from "../footer";

const AboutUs = () => {
    return (
        <>
            <Navbar menuColor="red" />

            <div></div>

            <div className="bg-light">

                {/* Hero Section */}
                <section className="py-5 bg-primary text-white">
                    <div className="container text-center">
                        <h1 className="fw-bold">About Lawyers Connect</h1>
                        <p className="mt-3 fs-5">
                            Connecting individuals and businesses with trusted legal professionals — anytime, anywhere.
                        </p>
                    </div>
                </section>

                {/* Who We Are */}
                <section className="py-5">
                    <div className="container">
                        <div className="row align-items-center g-4">
                            <div className="col-md-6">
                                <h2 className="fw-bold text-primary">Who We Are</h2>
                                <p className="text-muted mt-3">
                                    Lawyers Connect is a digital legal consultation platform designed to bridge
                                    the gap between clients and qualified legal practitioners. Our mission is
                                    to make legal services more accessible, transparent, and efficient.
                                </p>
                                <p className="text-muted">
                                    Whether you need legal advice, contract review, or representation guidance,
                                    our platform allows you to connect with experienced lawyers without delays
                                    or geographical limitations.
                                </p>
                            </div>
                            <div className="col-md-6 text-center">
                                <img
                                    src="/slidders/about_us_pic.png"
                                    alt="Legal professionals"
                                    className="img-fluid rounded-4 shadow"
                                />
                            </div>
                        </div>
                    </div>
                </section>

                {/* Our Mission & Vision */}
                <section className="py-5 bg-white">
                    <div className="container">
                        <div className="row g-4 text-center">

                            <div className="col-md-6">
                                <div className="card border-0 shadow h-100 rounded-4">
                                    <div className="card-body p-4">
                                        <h4 className="fw-semibold text-primary">Our Mission</h4>
                                        <p className="text-muted mt-3">
                                            To provide accessible, affordable, and reliable legal services
                                            through innovative digital solutions while upholding the highest
                                            standards of professionalism and ethics.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="card border-0 shadow h-100 rounded-4">
                                    <div className="card-body p-4">
                                        <h4 className="fw-semibold text-primary">Our Vision</h4>
                                        <p className="text-muted mt-3">
                                            To become a leading legal technology platform that empowers
                                            individuals and businesses to access justice with confidence and ease.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                {/* Why Choose Us */}
                <section className="py-5">
                    <div className="container">
                        <div className="text-center mb-5">
                            <h2 className="fw-bold text-primary">Why Choose Us</h2>
                            <p className="text-muted mt-2">
                                Built on trust, professionalism, and client satisfaction
                            </p>
                        </div>

                        <div className="row g-4">

                            <div className="col-md-4">
                                <div className="card h-100 border-0 shadow rounded-4 text-center">
                                    <div className="card-body p-4">
                                        <h5 className="fw-semibold">Verified Lawyers</h5>
                                        <p className="text-muted mt-2">
                                            All lawyers on our platform are thoroughly vetted,
                                            licensed, and experienced in their respective fields.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="card h-100 border-0 shadow rounded-4 text-center">
                                    <div className="card-body p-4">
                                        <h5 className="fw-semibold">Confidential Consultations</h5>
                                        <p className="text-muted mt-2">
                                            Your privacy is our priority. All consultations are secure,
                                            confidential, and protected by industry standards.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="card h-100 border-0 shadow rounded-4 text-center">
                                    <div className="card-body p-4">
                                        <h5 className="fw-semibold">Easy Access</h5>
                                        <p className="text-muted mt-2">
                                            Get legal help when you need it — no long queues,
                                            no unnecessary delays, just quick and reliable access.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                {/* Trust & Compliance */}
        

                 <section className="py-5 bg-primary text-white">
                    <div className="container text-center">
                        <h2 className="fw-bold">CAC CERTIFICATE</h2>
                        <p className="mt-3 fs-6">
                           <img  src="/CERTIFICATE-LAWYERS CONNECT LTD.png" alt="CAC Certificate - Lawyers Connect Ltd" />
                        </p>
                    </div>
                </section>

            </div>

            <Footer />
        </>
    );
};

export default AboutUs;